import PropTypes from 'prop-types'
import React from 'react'

const BuyCheckboxInput = ({
  label,
  update,
  verify = false,
  classes,
  value,
  spanClasses,
  name,
  labelInside,
  checked = false,
  disabled = false,
  dataCy,
}) => {
  const A120 = '#E0E0E0'
  return (
    <label
      className={`${classes} ${verify === false ? 'error' : ''} ${
        disabled ? 'disabled' : ''
      } ${checked ? 'checked' : ''}`}
      data-cy={dataCy}
    >
      {checked ? ( // BRUM-10233 - React 15 si comporta in modo strano e sono andato di ternario anziche' usare la key
        <input
          checked={value || checked}
          defaultChecked
          disabled={disabled}
          name={name}
          onChange={update}
          type="checkbox"
          value={value}
        />
      ) : (
        <input
          checked={value || checked}
          defaultChecked={false}
          disabled={disabled}
          name={name}
          onChange={update}
          type="checkbox"
          value={value}
        />
      )}

      <span
        className={spanClasses || 'check'}
        style={{
          backgroundColor: disabled ? A120 : null,
        }}
      >
        {labelInside}
      </span>
      {label.map((el, index) => (
        <React.Fragment key={`${name}_${index}`}>{el}</React.Fragment>
      ))}
    </label>
  )
}

BuyCheckboxInput.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  update: PropTypes.func.isRequired,
  classes: PropTypes.string,
  dataCy: PropTypes.string,
  name: PropTypes.string,
  spanClasses: PropTypes.string,
  verify: PropTypes.bool,
  checked: PropTypes.bool,
}

export default BuyCheckboxInput
